import { inject, Injectable, signal } from "@angular/core";
import { TenantAdministrationService } from "../../../../../services/api/tenant-administration/tenant-administration.service";

@Injectable()
export class SysAdminHomeService {
  // State variable for number of tenants:
  private readonly _numberOfTenants = signal<number | null>(null);
  readonly numberOfTenants = this._numberOfTenants.asReadonly();

  private tenantAdministration = inject(TenantAdministrationService);

  /**
   * Loads the initial state of the service by fetching the list of tenants and updating
   * the `numberOfTenants` state variable.
   */
  public loadInitialState() {
    this.resetStates();
    this.tenantAdministration.getTenants().subscribe({
      next: (tenants) => {
        this._numberOfTenants.set(tenants.length);
      },
    });
  }
  /**
   * Resets the state of the service, setting the number of tenants to `null`.
   */

  private resetStates() {
    this._numberOfTenants.set(null);
  }
}
